// SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>
//
// SPDX-License-Identifier: MPL-2.0
import { getApiUrl, isKeycloakEnabled } from '../../config.js';
import { post } from '../../utils/CoreService';

async function fetchSummary(text, length, model, topics = '') {
  const url = `${getApiUrl()}/summary/text`;

  const response = await post(url, {
    text,
    output_length: length,
    language_model: model,
    topics: topics,
  });

  return response;
}

export default fetchSummary;
